import { useState } from 'react';
import { useIntl } from 'react-intl';

import { Table, Column, Button } from '@marketplace/ui-elements';

import { Switcher } from './components';
import classes from './transaction-log.module.scss';

export const TransactionLog = ({apiResponseErrors}: any) => {
  const { formatMessage } = useIntl();

  const [selected, setSelected] = useState<'production' | 'sandbox'>(
    'production'
  );

  const isProduction = selected === 'production';

  const productionValue = [
    {
      timestamp: new Date('1999').toDateString(),
      status: 'committed',
      request: 'Join',
    },
    {
      timestamp: new Date('2021').toDateString(),
      status: 'committed',
      request: 'insert',
    },
    {
      timestamp: new Date('1994').toDateString(),
      status: 'committed',
      request: 'select',
    },
    {
      timestamp: new Date('1').toDateString(),
      status: 'committed',
      request: 'insert',
    },
  ];

  const sandboxValue = [
    {
      timestamp: new Date('1912').toDateString(),
      status: 'committed',
      request: 'Join',
    },
    {
      timestamp: new Date('2021').toDateString(),
      status: 'committed',
      request: 'Select',
    },
  ];

  const timestampHeaderLabel = formatMessage({
    id: 'transaction_log_timestamp',
  });
  const statusHeaderLabel = formatMessage({ id: 'transaction_log_request' });
  const requestHeaderLabel = formatMessage({ id: 'transaction_log_status' });

  return (
    <div>
      <div className={classes.switcher_wrapper}>
        <Switcher setSelected={setSelected} defaultChecked={selected} />
        <Button>{formatMessage({ id: 'transaction_log_refresh' })}</Button>
      </div>
      <Table value={isProduction ? productionValue : sandboxValue}>
        <Column field="timestamp" header={timestampHeaderLabel}></Column>
        <Column field="status" header={statusHeaderLabel}></Column>
        <Column field="request" header={requestHeaderLabel}></Column>
      </Table>
    </div>
  );
};
